import { Button, Link, FormControl, FormLabel, Input, Modal, ModalClose, ModalDialog, ModalOverflow, Stack, Typography, Select, Option, Autocomplete, Textarea, IconButton, Card, CardContent, Chip, Box, Stepper, Step, StepIndicator, CircularProgress, Divider, Checkbox } from "@mui/joy";
import { useContext, useEffect, useState } from "react";
import { LayoutContext } from "../../context";
import { motion, AnimatePresence } from "framer-motion";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { APICreateAdditionalPayment, APICreateEvent, APIGetCitys, APIGetEmployee, APIGetFiles, APIGetPrograms, APIUpdateBitrixFields, APIUpdateDeals, APIUpdateEvent, APIUploadFiles } from "../../api";
import Cookies from "js-cookie";
import CachedRoundedIcon from '@mui/icons-material/CachedRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

import classes from './ModalEvent.module.css';




export default function ModalAddService() {
    const { account, modalAddAdditionalService, setModalAddAdditionalService } = useContext(LayoutContext);
    const { getDeals, dealList, setDealList } = useContext(LayoutContext);
    
    const [ loading, setLoading ] = useState(false);
    const [ disabledBtn, setDisabledBtn ] = useState(false);
    const [ loadingDeal, setLoadingDeal ] = useState(false);
    const [isFullPriceVolume, setIsFullPriceVolume] = useState(false);
    
    const [ title, setTitle ] = useState();
    const [ customSurveyorPrice, setCustomSurveyorPrice ] = useState();
    const [ customDraftsmanPrice, setCustomDraftsmanPrice ] = useState();
    const [ calculationType, setCalculationType ] = useState('per_sqm');
    const [ inputLabel, setInputLabel ] = useState('');
    const [ inputUnit, setInputUnit ] = useState('');
    const [ percentBase, setPercentBase ] = useState('base_surveyor');



    function createPayEvent() {
        const _data = {
            payment_event_id: modalAddAdditionalService?.id_pay_event,
            custom_title: title,
            custom_surveyor_price: customSurveyorPrice,
            custom_draftsman_price: customDraftsmanPrice,
            full_price_volume: isFullPriceVolume,
            calculation_type: calculationType,
            input_label: calculationType === 'per_input' ? inputLabel : null,
            input_unit: calculationType === 'per_input' ? inputUnit : null,
            percent_base: calculationType === 'percent' ? percentBase : null,
        };
                
        setLoading(true);
        const token = Cookies.get("auth_token");
        APICreateAdditionalPayment(_data, token).then((data) => {
            // console.log(data);
            if (data?.status == 'ok'){
                const newService = data.data; // Объект созданной услуги
                    
                console.log(modalAddAdditionalService?.paymentEvent?.additional_services);
                if (modalAddAdditionalService?.paymentEvent) {
                    modalAddAdditionalService?.setPaymentEvent((prevEvent) => ({
                        ...prevEvent, // Копируем все данные из старого состояния
                        additional_services: [
                            ...(prevEvent.additional_services || []), // Берём существующие услуги или пустой массив
                            newService, // Добавляем новую услугу
                        ],
                    }));
                }

                setModalAddAdditionalService({ id_pay_event: null, paymentEvent: null, setPaymentEvent: null , open: false });
            }
            setLoading(false);
        });
    }


    return (
        <AnimatePresence>
            {
                modalAddAdditionalService.open && (
                    <Modal
                        sx={{ zIndex: 10103 }}
                        open={modalAddAdditionalService.open}
                        onClose={() => setModalAddAdditionalService({ id_pay_event: null, paymentEvent: null, setPaymentEvent: null , open: false })}
                        slotProps={{
                            backdrop: {
                                component: motion.div,
                                initial: { opacity: 0, backdropFilter: 'blur(0px)' },
                                animate: { opacity: 1, backdropFilter: 'blur(8px)' },
                                exit: { opacity: 0, backdropFilter: 'blur(0px)' },
                                transition: { duration: 0.3, ease: "easeInOut" },
                            }
                        }}
                    >
                        <ModalOverflow sx={{ height: 'auto' }}>
                            <ModalDialog
                                size="lg"
                                component={motion.div}
                                initial={{ opacity: 0, y: -10, scale: 0.98 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: 10, scale: 0.98 }}
                                transition={{ duration: 0.2, ease: "easeInOut" }}
                                sx={(theme) => ({
                                    [theme.breakpoints.up("xl")]: {
                                        width: '450px',
                                        mx: 0,
                                    },
                                    [theme.breakpoints.down("xl")]: {
                                        width: '450px',
                                        mx: 0,
                                    },
                                    [theme.breakpoints.down("lg")]: {
                                        width: '450px',
                                        mx: 0,
                                    },
                                    [theme.breakpoints.down("md")]: {
                                        width: '350px',
                                        mx: 0,
                                    },
                                    [theme.breakpoints.down("sm")]: {
                                        width: '95%',
                                        p: 3,
                                    },
                                    width: '100%'
                                })}
                            >
                                <ModalClose/>
                                <Typography sx={{ textAlign: 'center', mb: 0 }} level="h3">
                                    Создать услугу
                                </Typography>
                                {/* { error != "" &&
                                    <Typography sx={{ textAlign: 'center' }} color="danger" level="title-sm">
                                        {error}
                                    </Typography>
                                } */}

                                <Stack spacing={2}>
                                    <FormControl>
                                        <FormLabel>Название</FormLabel>
                                        <Input value={title} onChange={(e) => setTitle(e.target.value)} size="md" required placeholder="Название" />
                                    </FormControl>

                                    {/* ── тип расчёта ── */}
                                    <FormControl>
                                        <FormLabel>Тип расчёта</FormLabel>
                                        <Select value={calculationType} onChange={(_, v) => setCalculationType(v)} size="md">
                                            <Option value="per_sqm">За м² от площади события</Option>
                                            <Option value="fixed">Фиксированная сумма</Option>
                                            <Option value="percent">Процент от базовой ЗП</Option>
                                            <Option value="per_input">За единицу пользовательского ввода</Option>
                                        </Select>
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>{
                                            calculationType === 'fixed'    ? 'Сумма (Обмерщику)' :
                                            calculationType === 'percent'  ? 'Процент (Обмерщику), %' :
                                            calculationType === 'per_input'? `Стоимость за ${inputUnit || 'единицу'} (Обмерщику)` :
                                                                            'Стоимость за м² (Обмерщику)'
                                        }</FormLabel>
                                        <Input type="number" value={customSurveyorPrice}
                                            onChange={(e) => setCustomSurveyorPrice(e.target.value)} size="md" required placeholder="10" />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>{
                                            calculationType === 'fixed'    ? 'Сумма (Чертежнику)' :
                                            calculationType === 'percent'  ? 'Процент (Чертежнику), %' :
                                            calculationType === 'per_input'? `Стоимость за ${inputUnit || 'единицу'} (Чертежнику)` :
                                                                            'Стоимость за м² (Чертежнику)'
                                        }</FormLabel>
                                        <Input type="number" value={customDraftsmanPrice}
                                            onChange={(e) => setCustomDraftsmanPrice(e.target.value)} size="md" required placeholder="10" />
                                    </FormControl>

                                    {/* ── Поля для per_input ── */}
                                    {calculationType === 'per_input' && (
                                        <>
                                            <FormControl>
                                                <FormLabel>Название поля ввода</FormLabel>
                                                <Input value={inputLabel} onChange={(e) => setInputLabel(e.target.value)}
                                                    placeholder="Например: Длина периметра" size="md" required />
                                            </FormControl>
                                            <FormControl>
                                                <FormLabel>Единица измерения</FormLabel>
                                                <Input value={inputUnit} onChange={(e) => setInputUnit(e.target.value)}
                                                    placeholder="м.п. / м² / шт" size="md" required />
                                            </FormControl>
                                        </>
                                    )}

                                    {/* ── Поля для percent ── */}
                                    {calculationType === 'percent' && (
                                        <FormControl>
                                            <FormLabel>База для процента</FormLabel>
                                            <Select value={percentBase} onChange={(_, v) => setPercentBase(v)} size="md">
                                                <Option value="base_surveyor">От базы обмерщика (без допов)</Option>
                                                <Option value="base_draftsman">От базы чертёжника (без допов)</Option>
                                                <Option value="total_surveyor">От итога обмерщика (с допами)</Option>
                                                <Option value="total_draftsman">От итога чертёжника (с допами)</Option>
                                            </Select>
                                        </FormControl>
                                    )}

                                    <Button onClick={createPayEvent} loading={loading} size="lg" variant="solid" color="success" type="submit">
                                        Создать
                                    </Button>
                                </Stack>
                            </ModalDialog>
                        </ModalOverflow>
                    </Modal>
                )
            }
        </AnimatePresence>
    );
}